import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { retry, map, catchError } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { SharedService } from '../shared.service';
import { IGenericRestfulResponse }  from '../../interfaces/enrollment/generic-restful-response';

@Injectable({
  providedIn: 'root'
})
export class PasswordResetService {

  private readonly passwordResetUrl = "/pswd-recov/reset-pswd";
    
  constructor(
    private readonly http: HttpClient,
    private readonly sharedService: SharedService 
  ) { }

  // Submit a request with a new password
  public postPasswordReset(sessionId: string, userName: string, newPassword: string, signedJwt: string): Observable<IGenericRestfulResponse> {
    let url = this.getAuthServerUrl() + this.passwordResetUrl;
    let request = {
      userName: userName,
      newPassword: newPassword,
      signedJwt: signedJwt
    }
    let headers = new HttpHeaders()
      .set("request-origin", "csr-portal")
      .set('session-id', sessionId);
    return this.http.put<any>(url, request, {headers: headers, responseType: 'json'})
    .pipe(
        map(response => {
          console.log('postPasswordReset service - response', response);
          let res: IGenericRestfulResponse = {
            status: response.status,
            returnCode: response.returnCode,
            returnMessage: response.returnMessage,
            additionalInfo: new Map<string, string>(Object.entries(response.additionalInfo ?? {})) 
          };
          return res;
      }),
      catchError(this.sharedService.handleError)
    )
  }  
  
  private getAuthServerUrl() {
    return environment.settings.authUrl;
  }

}
